import { 
  MdDashboard, 
  MdBusiness,
  MdLogout,
  MdExpandLess,
  MdExpandMore,
  MdSettings,
  MdBarChart
} from 'react-icons/md';
import { RxDashboard } from 'react-icons/rx';
import { TbReportAnalytics } from "react-icons/tb";

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const SuperAdminSidebar = ({ isOpen, onToggle, onCloseSidebar, isMobile }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isReportsOpen, setIsReportsOpen] = useState(false);

  const reportsSubMenu = [
    { icon: <MdBusiness size={14} />, label: t('superAdmin.customerReport'), path: '/superadmin/reports/companies' },
    { icon: <MdBarChart size={14} />, label: t('superAdmin.systemStatistics'), path: '/superadmin/reports/statistics' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('superadmin_token');
    localStorage.removeItem('superadmin_user');
    navigate('/superadmin');
  };

  const menuItems = [
    { icon: <RxDashboard size={18} />, label: t('superAdmin.dashboard'), path: '/superadmin/dashboard' },
    { icon: <MdBusiness size={18} />, label: t('superAdmin.tenants'), path: '/superadmin/tenants' },
    { 
      icon: <TbReportAnalytics size={18} />, 
      label: t('superAdmin.reports'), 
      hasSubmenu: true,
      onClick: () => setIsReportsOpen(!isReportsOpen)
    },
    { 
      icon: <MdLogout size={18} />, 
      label: t('common.logOut'), 
      onClick: handleLogout,
      hasDivider: true
    },
  ];

  return (
    <div className={`
      fixed 
      left-0 
      h-full 
      bg-[#232b3b] dark:bg-gray-800
      transition-all 
      duration-300 
      shadow-[3px_0_8px_rgba(0,0,0,0.15)] 
      border-r 
      border-gray-700 dark:border-gray-600
      flex flex-col
      ${isMobile ? 'z-50' : 'z-10'}
      ${isMobile 
        ? (isOpen ? 'translate-x-0' : '-translate-x-full') + ' w-[290px]'
        : (isOpen ? 'w-[290px]' : 'w-[50px]')
      }
    `}>
      {/* Collapse/Expand butonu - Sadece desktop'ta göster */}
      {!isMobile && (
        <button
          onClick={onToggle}
          className="absolute -right-2.5 top-[26px] bg-[#232b3b] dark:bg-gray-800 p-0.5 shadow-sm border border-gray-700 dark:border-gray-600"
        >
          <MdExpandLess 
            className={`transition-transform duration-300 text-[#8d969d] dark:text-gray-400
              ${!isOpen ? 'rotate-90' : '-rotate-90'}`}
            size={12}
          />
        </button>
      )}
      
      <div className="py-6 flex-1 overflow-y-auto" style={{
        scrollbarWidth: 'none', /* Firefox */
        msOverflowStyle: 'none', /* Internet Explorer 10+ */
      }}>
        <style jsx>{`
          div::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
          }
        `}</style>
        {menuItems.map((item, index) => (
          <div key={index}>
            {item.hasDivider && (
              <div className={`mx-4 my-2 border-t border-gray-700 dark:border-gray-600 ${!isOpen && 'mx-2'}`} />
            )}
            <div>
              {item.hasSubmenu ? (
                <button
                  onClick={item.onClick}
                  className={`w-full flex items-center py-3 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-700 text-base cursor-pointer
                    ${(isOpen || isMobile) ? 'px-6' : 'justify-center px-4'}`}
                >
                  <span className="inline-block">{item.icon}</span>
                  {(isOpen || isMobile) && (
                    <div className="flex items-center justify-between flex-1">
                      <span className="ml-3 transition-opacity duration-300">{item.label}</span>
                      {item.hasSubmenu && (
                        <MdExpandMore 
                          className={`transition-transform duration-300 
                            ${(item.label === 'Raporlar' && isReportsOpen) ? 'rotate-180' : ''}`}
                          size={16}
                        />
                      )}
                    </div>
                  )}
                </button>
              ) : (
                <button
                  onClick={item.onClick || (() => {
                    navigate(item.path);
                    if (isMobile && onCloseSidebar) {
                      onCloseSidebar();
                    }
                  })}
                  className={`w-full flex items-center py-3 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-700 text-base
                    ${isOpen ? 'px-6' : 'justify-center px-4'}`}
                >
                  <span className="inline-block">{item.icon}</span>
                  {isOpen && (
                    <span className="ml-3 transition-opacity duration-300">{item.label}</span>
                  )}
                </button>
              )}
              
              {/* Reports Submenu */}
              {isOpen && item.label === t('superAdmin.reports') && isReportsOpen && (
                <div className="bg-[#2f354a] dark:bg-gray-700 py-1">
                  {reportsSubMenu.map((subItem, subIndex) => (
                    <button
                      key={subIndex}
                      onClick={() => {
                        navigate(subItem.path);
                        if (isMobile && onCloseSidebar) {
                          onCloseSidebar();
                        }
                      }}
                      className="w-full flex items-center py-2 px-8 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-600 text-sm"
                    >
                      <span className="inline-block">{subItem.icon}</span>
                      <span className="ml-3">{subItem.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
